window.getQS = function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
function getTlds(){
    var tlds;

    if (getQS('tlds') !== '')  {
        tlds = getQS('tlds').split(',');
    } else if (getQS('tld') !== '') {
        tlds = [getQS('tld').split(',')[0]];
        if (tlds[0] == 'xyz' || tlds[0] == 'us') {
            tlds[0] = 'co';
        }
    } else {
        tlds = ['co'];
    }

    return tlds;
}

App.controller('AccountCtrl', function($scope, $location, $rootScope, $routeParams, domainHelper){
	
	//check if formData is not set
	if(!$rootScope.selectedDomain){
		$location.path('/');
	}
	
	$scope.$watch('formAccount.$valid', function(){
		$rootScope.accountValidation = $scope.formAccount.$valid;
	});
	
});

App.controller('EmptyCtrl', function($scope, $rootScope, $location, $route, $timeout){
	void 0;
	$rootScope.suggestions = [];
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	$rootScope.showTitle = '';
	$rootScope.showSubtitle = '';

	$rootScope.domainError = false;
	$rootScope.available = false;

	$scope.dlpRequestError = false;
    $scope.dlpRequestMsg = '';
    $scope.dlpRequestResp = '';

	if($rootScope.toggleSignup)
		$rootScope.toggleSignup('hide');
	
	if(!$rootScope.firstTime && location.href.indexOf('store') != -1)
	{
		$rootScope.firstTime = true;
		if(getQS('o') == '1')
		{
			$timeout(function(){
				$location.path('/modal');
				$location.replace();
				$rootScope.showregmodal = true;
			}, 0);
		}
	}

	$rootScope.getPlan = function(plan) {
		$rootScope.showregmodal = true;
		$rootScope.selectedPlanModal = plan;
		//but heavens, please show viewcontainer
		$rootScope.toggleSignup('show');
		//wait let's check if user is logged in
		if(typeof POP.currentUser == 'object')
		{
			$location.url('/modal/existing/domains');
		} else {
			//go to domain view
			$location.path('/register');
			$location.replace();
		}
	}

});

App.controller('StarterPageCtrl', function($scope,$rootScope, $location) {
	//check for selectedDomain empty and reroute
	if(!$rootScope.selectedDomain) {
		$location.path('/register');
		$location.replace();
	}
});

App.controller('VerifyCtrl', function($routeParams, $rootScope, $scope, $location, validationHelper){

	//check if formData is not set, if not you reached this route from a link
	
	if($rootScope.selectedDomain == null)
	{
		$location.path('/register');
		$location.replace();
	}
	/*
	if($rootScope.formData.tmp_user_id)
	{
		$location.url('/register/complete');
	}
	*/
	
	$scope.validatePin = function()
	{
		$('.step-6-verify').trigger('click');
		
		$rootScope.validatePin();
	}

});

App.controller('EmailCtrl', function($scope, $rootScope, $location){

	//first check if we have formData from previous step
	if(!$rootScope.formData.comm_pref)
	{
		$location.path('/register');
		$location.replace();
	}

	$scope.$watch('formEmail.$valid', function(){
		$rootScope.validEmail = $scope.formEmail.comm_email.$valid;
	});
});

App.controller('DomainCtrl', function($scope, $route, $rootScope, domainService, $location){
	
	var timeout, $mainError = $('#main-error');

	$rootScope.suggestions = [];
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	$rootScope.showTitle = '';
	$rootScope.showSubtitle = '';

	$rootScope.domainError = false;
	$rootScope.available = false;

	$scope.dlpRequestError = false;
    $scope.dlpRequestMsg = '';
    $scope.dlpRequestResp = '';

	$scope.switchLogin = function() {
		$location.url('/modal/login');
	};

    $scope.$on('$routeChangeSuccess', function () {
        var $dlpTabs = $('.dlp-tabs');
        $dlpTabs.find('a[data-toggle="tab"]').on('show.bs.tab', function(ev) {
            //don't switch tabs if already searching... let it finish first
            if($rootScope.ajax) {
                return false;
            }
        });
        $dlpTabs.find('a[data-toggle="tab"]').on('shown.bs.tab', function(ev){
            var $t = $(ev.target);

            //stop search just in case they switched tabs before $rootScope.ajax has been set to true
            setTimeout(function () {
                domainService.stop();
            }, 610);

            if($t.hasClass('owndomain')){
                //hide steps breadcrumb
                $('.chevron-breadcrumb').hide();
                //hide suggestions and reset search input
                $('input.domain-form').val('');
                $rootScope.showSubtitle = '';
                $rootScope.showTitle = '';
                $rootScope.suggestions = [];
                $rootScope.available = false;
                $rootScope.$apply();
            }
            if($t.hasClass('newdomain')) {
                $('.chevron-breadcrumb').show();
            }
        });
    });

    $scope.dlpRequest = function () {
        if(typeof $.cookie('tracking_code') != 'undefined' ) {
			$rootScope.formData.tracking_code = $.cookie('tracking_code');
		}
        domainService.externalSignup($rootScope.formData).then(function (resp) {
            void 0;
            $scope.dlpRequestResp = resp;
            if(resp.code == 200) {
                //window.location = resp.redirect;
                $location.url(resp.redirect);
            } else {
                //error
                if(resp.errors) {
                    var errors = [];
                    for (var key in resp.errors) {
                        for (var key2 in resp.errors[key]) {
                            errors.push(resp.errors[key][key2]);
                        }
                    }
                }
                $scope.dlpRequestError = errors;
                $scope.dlpRequestMsg = resp.msg;
            }
        });
    };

	$scope.checkDomain = function(delay)
	{
		$rootScope.showTitle = '';
		$rootScope.showSubtitle = '';

		$rootScope.selectedDomain = null;
		$rootScope.selectedStarterPage = null;
		$rootScope.showAlerts = false;
		$rootScope.showResendMessage = false;
		$rootScope.available = false;
		$rootScope.domainError = false;

		if(delay === true)
		{
			domainService.stop();

			if(timeout)
			{
				clearTimeout(timeout);
			}
			
			//only search if the value is greater than 2
			if($rootScope.formData.domain.length >= 2)
			{
				timeout = setTimeout(function(){
					void 0;
					if($rootScope.formDomain.$valid === true)
					{
						checkAvailable($rootScope.formData.domain);
					} else {
                        var domains = '.' + $rootScope.anytld.join(', .').toUpperCase();
                        var st = "Try a "+ domains +" (they're free!)";
                        st = st.replace(/,(?![\s\S]*,)/g, ' or ');
                        if($rootScope.anytld.length === 1) {
                            st = st.replace("they're", "it's");
                        }
                        $rootScope.domainError = true;
                        $rootScope.showTitle = "Whoops...";
                        $rootScope.showSubtitle = st;
                        $rootScope.$apply();
                    }
					//$rootScope.setFormOffset();
				},600);
			}
		}
	}

	$rootScope.selectDomain = function(domainObj) {
		//tag inspectlet
		if(typeof __insp != 'undefined')
		{
			__insp.push(['tagSession',{domain:domainObj.Domain}]);
		}

		//set global selectedDomain
		$rootScope.selectedDomain = domainObj;

		if(typeof domainObj.TLD === 'undefined')
			$rootScope.selectedDomain.TLD = domainObj.Domain.split('.')[1];

		void 0;
		
		//hide suggestions
		$rootScope.suggestions = [];
		//hide available
		$rootScope.available = false;

		//before we go to next step, verify domain is valid
		//checkAvailable($rootScope.selectedDomain.Domain,true,false);
		$rootScope.nextStep();
	}

	$rootScope.setFormOffset = function(){
		// set variables
		$rootScope.domainSuggestionsVisible = $(".domain-suggestion-wrapper").is(":visible");
		if( !$rootScope.domainSuggestionsVisible ){
			POP.scrollTo("#domain", true, true );
		} else {
			POP.scrollTo("#closeSignup", true, false, 0 );
		}
	}

	function checkAvailable(domain,next,showsuggestions) {
		domainService.checkTld(domain).then(function(resp){

			void 0;
			
			//check if it is a response and not empty string from a cancel
			if( typeof resp == 'object' )
			{
				$rootScope.domainError = false;
				$rootScope.available = false;
				if(resp.code === 200)
				{
					//check for available == true here
					if(resp.available === true && resp.similar_domains.length > 0)
					{
						/*
						resp.msg = 'This domain is available. Hit "Get Started" if you want it!';
						POP.Message.response($mainError, resp);
						$rootScope.showAlerts = true;
						*/
						$rootScope.showTitle = 'This Domain is Available';
						$rootScope.showSubtitle = 'Nice choice';
						$rootScope.available = true;
					} else {
						$rootScope.showTitle = 'This Domain is Not Available';
						$rootScope.showSubtitle = 'Please search again';
						$rootScope.available = false;
						$rootScope.domainError = true;
					}
					if(next === true)
					{
						$rootScope.nextStep();
					}
				} else {
					$rootScope.domainError = true;
					//check for blacklisted
					if(resp.blacklisted === true)
					{
						$rootScope.showTitle = 'This Domain is Blacklisted';
						if(resp.similar_domains.length > 0)
							$rootScope.showSubtitle = 'Choose from the options below, or search again.';
						else
							$rootScope.showSubtitle = '';
					} else if(resp.available === false){
						$rootScope.showTitle = 'This Domain is Not Available';
						if(resp.similar_domains.length > 0)
							$rootScope.showSubtitle = 'Choose from the options below, or search again.';
						else
							$rootScope.showSubtitle = '';
					} else {
						POP.Message.response($mainError,resp, false, false);
						$rootScope.showAlerts = true;
					}
				}

				//check if similar_domains is populated
				if(typeof resp.similar_domains != 'undefined' && resp.similar_domains.length > 0)
				{
					$rootScope.mainSuggestion = resp.similar_domains.shift();
					//do yer thing
					$rootScope.suggestions = resp.similar_domains;
				} else {
					$rootScope.mainSuggestion = null;
				}
			}

		}, function(error){
			void 0;
		});
	}

});

App.controller('CellCtrl', function($scope, $rootScope, $location){

	$rootScope.formData.cell_countrycode = "US"
    $rootScope.formData.cell_countrycode_numeric = 1;
	$rootScope.formData.cell = '';
    $rootScope.cellErrors = false;
    $rootScope.validCell = false;
});

App.controller('CompleteCtrl', function($routeParams, $rootScope, $scope, $location, validationHelper){
	
	$rootScope.success = false;

	if($rootScope.selectedDomain == null){
		$location.path('/register');
		$location.replace();
	}

	$scope.$watch('formComplete.$valid', function(){
		$rootScope.completeValid = $scope.formComplete.$valid;
	});

});

App.controller('ContactCtrl', function($scope, $location, $rootScope, $routeParams, domainHelper){
	
	$rootScope.selectedStarterPage = null;
	$rootScope.showAlerts = false;

	//check if formData is not set
	if(!$rootScope.selectedDomain){
		//check querystring first
		if($routeParams.d)
		{
			validateDomain($routeParams.d);
		} else if($.cookie('pop_domain')) {
			//if cookie not set, redirect to first step
			$location.path('/register');
			$location.replace();
		} else {
			validateDomain($.cookie('pop_domain'));
		}
	}
		
	$scope.$watch('formInfo.$valid', function(){
		$rootScope.validEmailInfo = $scope.formInfo.$valid;
	});
	
	function validateDomain(value) {
		// let's validate the domain, just in case
		domainHelper.validateDomain(value, function(result){
			//set formData.domain from querystring
			$rootScope.formData.domain = value;
			if (result == false) {
				//redirect to first step
				$location.path('/register');
				$location.replace();
			}
		});
	}

});

App.controller('UserPassCtrl', function($scope,$location,$rootScope) {
	
	$scope.$watch('formUser.$valid', function(){
		$rootScope.validUserPass = $scope.formUser.$valid;
	});

	$rootScope.$watch('formData.firstname', function(){
		if(typeof $rootScope.formData.firstname != 'undefined')
			$rootScope.formData.username = $rootScope.formData.firstname.replace(/ /g,"-");
	});

});
